import services from 'services';
import { detectBrowserHidden } from 'helpers';
import { BroadcastChannel } from 'broadcast-channel';

export const keyVersion = 'version';
export const versionChannel = 'versionChannel';

class VersionService {
  broadCast() {
    return {
      startListen: () => {
        const channel = new BroadcastChannel(versionChannel);
        channel.addEventListener('message', (event) => {
          if (event === 'reload') {
            const { isHidden } = detectBrowserHidden();
            if (isHidden) {
              window.location.reload();
            }
          }
        });
      },

      forceReload: () => {
        const channel = new BroadcastChannel(versionChannel);
        channel.postMessage('reload');
      },
    };
  }

  checkVersionFromServer() {
    return services.get('/internal/api/status-check');
  }

  getVersion() {
    return sessionStorage.getItem(keyVersion);
  }

  setNewVersion(newVersion) {
    return sessionStorage.setItem(keyVersion, newVersion);
  }
}

export default new VersionService();
